// test38
(38 && 0);
